<template>
  <div class="bank-register f-w3">
    <img src="../assets/image/bank-register.svg" alt="" />
    <div class="no-bank f-w3">あなたは銀行口座を持っていません</div>
    <button class="next-register f-w3" @click="nextRegisterBank">
      口座登録はこちら
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "bankAccRegister",
  computed: {
    ...mapGetters({
      auth: "auth/user"
    })
  },
  methods: {
    nextRegisterBank() {
      let genderRouter = "CastMyPage";
      if (this.auth.sex === 1) {
        genderRouter = "MenMyPage";
      }
      this.$root.$refs.loading.start();
      this.$router.push({ name: genderRouter + "BankAccountRegistration" });
      this.$root.$refs.loading.finish();
    }
  }
};
</script>

<style scoped lang="scss">
.bank-register {
  width: 335px;
}
img {
  margin-top: 6px;
  margin-right: 35px;
}
.no-bank {
  margin-top: 30px;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
}
.next-register {
  margin-top: 35px;
  margin-bottom: 17px;
  width: 100%;
  height: 45px;
  border-radius: 5px;
  background-color: #464d77;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (min-width: 1079px) {
  .bank-register {
    width: 463px;
  }
  img {
    width: 199.85px;
    height: 251px;
    margin-top: 32px;
  }
  .no-bank {
    margin-top: 35px;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
  }
  .next-register {
    margin: 35px auto 0;
    margin-bottom: 27px;
    width: 453px;
    height: 45px;
    border-radius: 5px;
    background-color: #464d77;
    font-size: 20px;
    line-height: 25px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
